/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TravelPreferencesUpdateRequest
 */
export interface TravelPreferencesUpdateRequest {
    /**
     * Free-text travel preferences
     * @type {string}
     * @memberof TravelPreferencesUpdateRequest
     */
    userPreferences: string;
}

/**
 * Check if a given object implements the TravelPreferencesUpdateRequest interface.
 */
export function instanceOfTravelPreferencesUpdateRequest(value: object): value is TravelPreferencesUpdateRequest {
    if (!('userPreferences' in value) || value['userPreferences'] === undefined) return false;
    return true;
}

export function TravelPreferencesUpdateRequestFromJSON(json: any): TravelPreferencesUpdateRequest {
    return TravelPreferencesUpdateRequestFromJSONTyped(json, false);
}

export function TravelPreferencesUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelPreferencesUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'userPreferences': json['user_preferences'],
    };
}

export function TravelPreferencesUpdateRequestToJSON(json: any): TravelPreferencesUpdateRequest {
    return TravelPreferencesUpdateRequestToJSONTyped(json, false);
}

export function TravelPreferencesUpdateRequestToJSONTyped(value?: TravelPreferencesUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_preferences': value['userPreferences'],
    };
}

